<template>
  <div>
    <el-upload
      :action="globalData.host+path"
      :headers="{'account-id':$store.state.LoginUser.accountId,'accessToken':$store.state.LoginUser.accessToken}"
      :multiple="false"
      :name="names"
      :show-file-list="false"
      :on-success="success"
      :on-error="error"
      :before-upload="beforeUpload">
      <el-button type="success" plain icon="el-icon-upload2" ><slot></slot></el-button>
    </el-upload>
    <!--<el-popover  v-popover:popover-->
      <!--ref="popover"-->
      <!--placement="top-start"-->
      <!--title="提示"-->
      <!--width="200"-->
      <!--trigger="hover">-->
      <!--<template>-->
        <!--&lt;!&ndash;请使用模版导入 <a :href="globalData.resourceUrl+'smartfact/template/user.xlsx'" target="_blank" download>下载模版</a>&ndash;&gt;-->
        <!--请使用模版导入 <a class="blue" @click="$export(tempLink)">下载模版</a>-->
      <!--</template>-->
    <!--</el-popover>-->
  </div>
</template>
<script>
  export default{
    name: 'upload-button',
    props:['file-char','url','temp-url'],
    data(){
        console.log(this.url);
      return {
          names:this.fileChar || 'file',
          path:this.url || '',
          tempLink:this.tempUrl || ''
      }
    },
    methods:{
      success(data){
        if(data.code == 200){
            this.$success('导入成功！')
        }else{
            this.$error(data.msg)
        }
      },
      error(data){
        this.$error(data.msg)
      },
      beforeUpload(file){

      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/UploadButton.vue